"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringListTrim = void 0;
function stringListTrim(list) {
    return (list === null || list === void 0 ? void 0 : list.length) ? (list.length === 1 ? list[0] : `${list[0]} +${list.length - 1}`) : '';
}
exports.stringListTrim = stringListTrim;
exports.default = stringListTrim;
